
import HttpClient from '../HttpService';

function create(data) {
    return HttpClient.post(`/tasknotes`, data);
}

function list(page, limit, data) {
    return HttpClient.post(`/tasknotes/list?page=${page}&limit=${limit}`, data);
}

function update(data) {
    return HttpClient.put(`/tasknotes/${data.id}`, data);
}

function removeFile(requestNoteId, fileId, data) {
    return HttpClient.delete(`/meetings/${requestNoteId}/files/${fileId}`, data);
}

function destroy(requestNoteId) {
    return HttpClient.delete(`/tasknotes/${requestNoteId}`);
}

export default {
    destroy,
    list,
    create,
    update,
    removeFile
}
